import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import "./SendCampaign.css";

const SendTextCampaign = () => {
  const [mobile_no, setMobile_No] = useState("");
  const [count, setCount] = useState(0);
  const [numbercounter, setNumberCounter] = useState("");
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [contactGroupData, setContactGroupData] = useState([]); // Added for group import
  
  // Calculate message count based on template content (160 characters = 1 message)
  const messageCount = selectedTemplate && selectedTemplate.templateFormat 
    ? Math.ceil(selectedTemplate.templateFormat.length / 160) 
    : 0;
  
  // Calculate total credits required (message count * number of recipients)
  const totalCreditsRequired = messageCount * count;

  const token = localStorage.getItem("token");
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    fetchTemplates();
    fetchContactGroups(); // Fetch contact groups on mount
  }, []);

  useEffect(() => {
    const theme = localStorage.getItem("theme");
    document.body.className = theme;
    if (numbercounter.length == 0) {
      setNumberCounter(0);
    }
  }, [count]);

  const fetchTemplates = () => {
    axios
      .post(
        `${BASE_URL}admin/getAllTextTemplates`,
        { statusFilter: "approved" },
        {
          headers: {
            "x-access-token": `${token}`,
            version: "1.0.0",
            "Content-Type": "Application/json",
          },
        }
      )
      .then((response) => {
        setTemplates(response.data.data.data || []);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchContactGroups = () => { // New function for group import
    axios
      .post(
        `${BASE_URL}admin/getAllContactGroup`,
        { page: 1 },
        {
          headers: {
            "x-access-token": `${token}`,
            version: "1.0.0",
            "Content-Type": "Application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.success !== false) {
          setContactGroupData(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const RowCount = (text) => {
    var lines = text.split(/\r|\r\n|\n/);
    setCount(lines.length);
    setNumberCounter(count);
    setMobile_No(text);
  };

  const GroupRowCount = (text) => { // New function for group import
    var lines = text.split(/\r|\r\n|\n/);

    setCount(lines.length);

    setNumberCounter(count);
    setMobile_No(text);
  };

  const submitTextMessage = () => {
    setLoading(true);
    if (!selectedTemplate) {
      toast.error("Template selection is mandatory");
      setLoading(false);
      return;
    }
    if (!mobile_no) {
      toast.error("Mobile numbers are mandatory");
      setLoading(false);
      return;
    }
    axios
      .post(
        `${BASE_URL}admin/addSendMessage`,
        {
          contact_no: mobile_no,
          msg_count: count,
          template_id: selectedTemplate._id, // Send template_id
          media_type: "TEXT",
        },
        {
          headers: {
            "x-access-token": `${token}`,
            version: "1.0.0",
            "Content-Type": "Application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.success) {
          toast.success("Text message sent successfully");
          setMobile_No("");
          setCount(0);
          setNumberCounter("");
          setSelectedTemplate(null);
        } else {
          toast.error(response.data.message || "Failed to send text message");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to send text message");
        setLoading(false);
      });
  };

  return (
    <div className="send-campaign-container">
      <div className="send-campaign-card card">
        <div className="send-campaign-header card-header">
          <h6>Send Text Message Campaign</h6>
        </div>
        <div className="send-campaign-body card-body">
          {/* Mobile Numbers */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Mobile Numbers</label>
            <textarea
              className="form-control-responsive"
              rows="4"
              placeholder="Enter mobile numbers (one per line)"
              value={mobile_no}
              onChange={(e) => RowCount(e.target.value)}
            />
          </div>

          {/* Template Selection */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Select Template:</label>
            <select
              className="form-control-responsive"
              value={selectedTemplate ? selectedTemplate._id : ""}
              onChange={(e) => {
                const selectedId = e.target.value;
                const template = templates.find((t) => t._id === selectedId);
                setSelectedTemplate(template || null);
              }}
            >
              <option value="" disabled>
                Select text template
              </option>
              {templates.map((template) => (
                <option key={template._id} value={template._id}>
                  {template.templateName}
                </option>
              ))}
            </select>
          </div>

          {/* Numbers Count */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Numbers Count:</label>
            <input
              type="text"
              className="form-control-responsive"
              name="numbercounter"
              value={count}
              disabled
            />
          </div>

          {/* Group Import */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Group Import</label>
            <select
              className="form-control-responsive"
              onChange={(e) => GroupRowCount(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>--select--</option>
              {contactGroupData &&
                contactGroupData.map((item, index) => (
                  <option key={index} value={item.contact_no}>
                    {item.group_name}
                  </option>
                ))}
            </select>
          </div>

          {/* Submit Button */}
          <div className="submit-btn-container">
            {loading ? (
              <button type="button" className="btn btn-primary " disabled>
                <i className="fa fa-spinner fa-spin  "></i>
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-primary "
                onClick={submitTextMessage}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendTextCampaign;